let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lIMhp")).then(() => parcelRequire('ibkW0'));